import { IApplicationState } from '../../types/redux';

export const getEscrowHouses = (state: IApplicationState) => {
  const { newbuilding } = state;
  const { houses } = newbuilding;

  return houses.filter(house => house.isEscrow);
};
